"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoAddons;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _BuyAddonsButton = _interopRequireDefault(require("./BuyAddonsButton"));
var _r10SourceLibrary = require("r10-source-library");
var _appConstants = require("../appConstants");
var _reactRouterDom = require("react-router-dom");
var _updateModeParam = _interopRequireDefault(require("../utils/updateModeParam"));
var _Actions = require("../actions/Actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function NoAddons() {
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleEligibleAddonsVisibility = function handleEligibleAddonsVisibility() {
    dispatch((0, _Actions.sendTags)({
      taggingId: 'CUSTOMER_DASHBOARD_ADDONS_11',
      taggingType: 'link',
      taggingValue: {}
    }));
    (0, _updateModeParam.default)(history, _appConstants.MODES.sellable);
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "add-ons",
    appearance: "secondary",
    size: 4,
    group: "hifiLight"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 4,
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    justify: "center",
    dataAttributes: {
      'data-testid': 'no-addons'
    }
  }, t('noAddons'))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_BuyAddonsButton.default, {
    showEligibleAddons: handleEligibleAddonsVisibility
  }))));
}